import {Pipe, PipeTransform} from '@angular/core';
import {get} from 'lodash';

@Pipe({
  name: 'getDisplayValue',
  pure: true
})
export class GetDisplayValuePipe implements PipeTransform {
  transform(value: any, displayValueField: string): string {
    return displayValueField ? get(value, displayValueField) : value;
  }
}
